import { Warning } from '@phosphor-icons/react'
import React from 'react'

import { RootS } from './AlertLocal.styled'

interface AlertLocalPropsI {
  message: string,
  className?: string
}

const AlertLocal = (props?: AlertLocalPropsI) => {
  return (
    <RootS className={props?.className}>
      <Warning size={32} color="black" />
      <p>
        {props?.message}
      </p>
    </RootS>
  )
}

export default AlertLocal
